<template lang="pug">
  main
    NavBarRequisiciones
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Firmar Requisición &nbsp
              a.button.is-rounded.is-black(@click="backRequisiciones")
                i.fas.fa-times
        .columns
          .column
            CardRequisicion(:requisicion="dataRequision")
        .columns
          .column
            Signature(@saveFile="checkFile")
        .columns.column-blanco
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarRequisiciones from './layout/NavBarRequisicion.vue'
  import CardRequisicion from './CardRequisicion.vue'
  import Signature from './Signature.vue'
  import { mapState } from 'vuex'
  import InventarioServices from '../../services/inventario/inventario'

  export default {
    name: 'FormFirma',
    components: { Loader, NavBarRequisiciones, Signature, CardRequisicion },
    data() {
      return {
        isLoading: true,
        dataRequision: {},
        firma: '',
        nombreFile: '',
        estadoNew: 0
      }
    },
    methods: {
      iniciarComponente() {
        this.dataRequision = this.requisicion_firma
        this.estadoNew = parseInt(this.estadoReq) + 1
        switch (this.estadoReq) {
          case 0:
            this.nombreFile = `FirmaSol_${this.requisicion_firma.id_requisicion}`
            break
          case 1:
            this.nombreFile = `FirmaGP_${this.requisicion_firma.id_requisicion}`
            break
          case 2:
            this.nombreFile = `FirmaJA_${this.requisicion_firma.id_requisicion}`
            break
          case 3:
            this.nombreFile = `FirmaGA_${this.requisicion_firma.id_requisicion}`
            break
          case 4:
            this.nombreFile = `FirmaGG_${this.requisicion_firma.id_requisicion}`
            break
          default:
            break
        }
        this.isLoading = false
      },
      checkFile (file) {
        console.log(file)
        this.firma = file

        if (this.firma !== 'NoData') {
          InventarioServices.firmarRequisicion(this.requisicion_firma.id_requisicion, this.firma, this.nombreFile, this.estadoNew )
            .then( data => {
              console.log(data)
              if (data.success) {
                let toast = this.$toasted.show(`La Requisicion ${this.requisicion_firma.id_requisicion} ha sido firmada.`, { 
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 3000,
                  iconPack: 'fontawesome',
                  icon: 'check',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                })
                this.backRequisiciones()
              } else {
                let toast = this.$toasted.show(`Erro: ${this.data.respuesta} ha sido firmada.`, { 
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 3000,
                  iconPack: 'fontawesome',
                  icon: 'ban',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                })
              }
            })
            .catch( e => console.log(e))
        } else {
          console.log('No Guardar la Firma')
          let toast = this.$toasted.show('Error: No se ha firmado aún la requisición.', { 
            theme: "toasted-primary", 
            position: "bottom-right", 
            duration : 3000,
            iconPack: 'fontawesome',
            icon: 'ban',
            action : {
              text : 'Ok',
              onClick : (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
          })
        }
      },
      backRequisiciones () {
        this.$store.commit('firmaRequisicion', {})
        this.$router.back()
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'requisicion_firma', 'estadoReq'])
    },
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/FormFirma.vue